module.exports = __webpack_public_path__ + "static/media/kitchen-4.32ab0c99.jpg";